import type { PlaygameMessage } from '@playgame/types'
import { createSharedComposable, usePlaygameState } from '#imports'

export const usePlaygameMessage = createSharedComposable(() => {
    const { _writableMessage: message } = usePlaygameState()

    const addMessage = (newMessage: PlaygameMessage) => {
        message.value = newMessage
    }

    const removeMessage = () => {
        message.value = null
    }

    const clearMessage = () => {
        message.value = null
    }

    return {
        addMessage,
        removeMessage,
        clearMessage
    }
})
